import HelpIcon from '@mui/icons-material/Help';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  Button,
  Checkbox,
  Container,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import Tooltip from '@mui/material/Tooltip';
import maskCPF from 'components/Masks/maskCPF';
import maskPhone from 'components/Masks/maskPhone';
import PlatformLogo from 'components/PlatformLogo';
import { useFormik } from 'formik';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { LINK_TO_PRIVACY_POLICY } from 'utils/consts';
import * as Yup from 'yup';
import { useStyles } from '../../components/Styles';
import logoBludocc2 from '../../images/bludocc-logo2.png';
import { setAuthentication } from '../../redux/authenticated';
import { setNameProperty } from '../../redux/nameProperty';
import { setNameUser } from '../../redux/nameUser';
import api from '../../services/api';
import DialogForgotPass from '../signin/dialogForgotPass';
import DialogContact from './dialogContact';
import DialogPropertyOrUserExists from './dialogPropertyOrUserExists';
import styles from './styles.module.css';

export const withRouter = (Component) => {
  function Wrapper(props) {
    const history = useHistory();
    return <Component history={history} {...props} />;
  }
  return Wrapper;
};

function IconWithTooltipSenha() {
  return (
    <Tooltip
      title="A senha deve conter ao menos 6 caracters. A senha deve conter ao menos uma letra minúscula, uma letra maíscula e um número."
      placement="right"
      arrow
    >
      <HelpIcon color="primary" fontSize="inherit" />
    </Tooltip>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Register(props) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state) => state.authenticated.authenticated
  );
  const [isInvite, setIsInvite] = useState(isAuthenticated);
  const classes = useStyles();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSend, setShowSend] = useState(true);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [contractAccepted, setContractAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialogPropertyExists, setOpenDialogPropertyExists] =
    useState(false);
  const [openDialogForgotPass, setOpenDialogForgotPass] = useState(false);
  const [message, setMessage] = useState('');
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const recommendation =
    searchParams.get('recommendation') !== ''
      ? searchParams.get('recommendation')
      : null;

  const { error } = useDependencyInjection();

  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      password_confirmation: '',
      cpf: '',
      phone: '',
      check: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required('Campo Obrigatório')
        .max(100, 'Máximo de 100 Caracteres')
        .nullable(),
      last_name: Yup.string()
        .required('Campo Obrigatório')
        .max(100, 'Máximo de 100 Caracteres')
        .nullable(),
      email: Yup.string()
        .email('Digite um email válido')
        .required('Campo Obrigatório')
        .max(100, 'Máximo de 100 Caracteres'),
      password: Yup.string()
        .matches(
          /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))/,
          'A senha deve conter ao menos uma letra minúscula, uma letra maiúscula e um número'
        )
        .min(6, 'A senha deve conter ao menos 6 caracteres')
        .max(100, 'Máximo de 100 Caracteres')
        .required('Campo Obrigatório'),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref('password'), null], 'As senhas devem ser iguais!')
        .required('Campo Obrigatório'),
      cpf: Yup.string()
        .matches(
          /^[0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2}$/,
          'O número digitado não é válido.'
        )
        .required('Campo Obrigatório'),
      phone: Yup.string()
        .matches(
          /^[(][0-9]{2}[)][\s]?[0-9]{5}[-]?[0-9]{4}$/,
          'O número digitado não é válido.'
        )
        .required('Campo Obrigatório'),
      check: Yup.boolean().oneOf([true], 'Você deve aceitar os termos de uso!'),
    }),

    onSubmit: (values) => {
      const data = {
        ...values,
        permissions: ['admin'],
        recommendation,
      };
      request(data);
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  async function request(data) {
    try {
      setLoading(true);
      const url = '/users/new-user';

      const dataMapper = {
        email: data.email,
        password: data.password,
        professional_qualification: 'Administrador',
        name: `${data.first_name} ${data.last_name}`,
        cpf_cnpj: data.cpf,
        phone: data.phone,
        permissions: data.permissions,
        recommendation,
      };

      const payload = { ...dataMapper };

      await api.post(url, { ...payload }).then(() => {
        localStorage.setItem('concluirCadastro', true);
        history.push('/signin', { email: data.email });
      });
    } catch (err) {
      const { statusCode, message: messageError } = err.response.data;
      if (statusCode === 409) {
        setMessage(messageError);
        setOpenDialogPropertyExists(true);
      } else {
        setOpenDialogPropertyExists(true);
      }
    }
    setLoading(false);
  }

  function onChangeRecaptcha(value) {
    setShowSend(false);
  }

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpenError(false);
  }

  function handleLogout() {
    dispatch(setNameProperty(''));
    dispatch(setNameUser(''));
    dispatch(setAuthentication(false));
  }

  function changeContractAccepted() {
    setContractAccepted(true);
    formik.handleSubmit();
  }

  return (
    <>
      <Container className={styles.container}>
        <Paper className={styles.paper}>
          <form
            onSubmit={formik.handleSubmit}
            style={{
              padding: '2rem 0rem 2rem 0rem',
            }}
          >
            {openDialogPropertyExists && (
              <DialogPropertyOrUserExists
                message={message}
                email={formik.email}
              />
            )}
            <Typography variant="h6" align="center" gutterBottom>
              <PlatformLogo isLogin srcLogoBludocc={logoBludocc2} />
            </Typography>

            <h2 style={{ textAlign: 'center', padding: '2rem' }}>
              CRIAR UMA CONTA GRATUITA
            </h2>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div style={{ textAlign: 'center' }}>
                  <FormGroup>
                    <TextField
                      id="formGridFirstName"
                      label="Nome"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      name="first_name"
                      placeholder="Primeiro nome"
                      type="text"
                      value={formik.values.first_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        !!(
                          formik.touched.first_name && formik.errors.first_name
                        )
                      }
                      helperText={
                        formik.touched.first_name && formik.errors.first_name
                      }
                    />
                  </FormGroup>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ textAlign: 'center' }}>
                  <FormGroup>
                    <TextField
                      id="formGridLastName"
                      label="Sobrenome"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      name="last_name"
                      placeholder="Seu segundo nome"
                      type="text"
                      value={formik.values.last_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        !!(formik.touched.last_name && formik.errors.last_name)
                      }
                      helperText={
                        formik.touched.last_name && formik.errors.last_name
                      }
                    />
                  </FormGroup>
                </div>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormGroup>
                  <TextField
                    id="cpf"
                    label="CPF"
                    placeholder="000.000.000-00"
                    name="cpf"
                    variant="outlined"
                    InputLabelProps={{
                      style: { pointerEvents: 'auto' },
                      shrink: true,
                    }}
                    value={formik.values.cpf}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    InputProps={
                      maskCPF && {
                        inputComponent: maskCPF,
                      }
                    }
                    error={!!(formik.touched.cpf && formik.errors.cpf)}
                    helperText={formik.touched.cpf && formik.errors.cpf}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormGroup>
                  <TextField
                    fullWidth
                    id="phone"
                    label="Telefone"
                    placeholder="(00) 00000-0000"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    name="phone"
                    type="text"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    InputProps={{
                      inputComponent: maskPhone,
                    }}
                    error={!!(formik.touched.phone && formik.errors.phone)}
                    helperText={formik.touched.phone && formik.errors.phone}
                  />
                </FormGroup>
              </Grid>

              <Grid item xs={12}>
                <div style={{ textAlign: 'center' }}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{
                        style: { pointerEvents: 'auto' },
                        shrink: true,
                      }}
                      id="formGridResp"
                      label="Email"
                      variant="outlined"
                      name="email"
                      placeholder="nome@exemplo.com"
                      type="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!(formik.touched.email && formik.errors.email)}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </FormGroup>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ textAlign: 'center' }}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{
                        style: { pointerEvents: 'auto' },
                        shrink: true,
                      }}
                      id="formGridResp"
                      label={
                        <div>
                          Senha <IconWithTooltipSenha />
                        </div>
                      }
                      variant="outlined"
                      name="password"
                      placeholder="Senha"
                      type={showPassword ? 'text' : 'password'}
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      error={
                        !!(formik.touched.password && formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                    />
                  </FormGroup>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ textAlign: 'center' }}>
                  <FormGroup>
                    <TextField
                      id="formGridResp"
                      label="Confirmar senha"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      name="password_confirmation"
                      placeholder="Repetir senha"
                      type={showConfirmPassword ? 'text' : 'password'}
                      value={formik.values.password_confirmation}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowConfirmPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      error={
                        !!(
                          formik.touched.password_confirmation &&
                          formik.errors.password_confirmation
                        )
                      }
                      helperText={
                        formik.touched.password_confirmation &&
                        formik.errors.password_confirmation
                      }
                    />
                  </FormGroup>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Checkbox
                  id="formGridResp"
                  name="check"
                  contractAccepted={changeContractAccepted}
                  checked={formik.values.check}
                  onChange={formik.handleChange}
                />
                <Typography component="span">
                  Você concorda com a
                  <a
                    href={LINK_TO_PRIVACY_POLICY}
                    target="_blank"
                    download="Politica_de_privacidade_e_segurança_Greenfy.pdf"
                    style={{ color: '#0666C2', textDecoration: 'none' }}
                    rel="noreferrer"
                  >
                    {' '}
                    política de privacidade e segurança da informação.{' '}
                  </a>
                </Typography>
                <br />
                <Typography style={{ color: 'red', marginLeft: '0.8rem' }}>
                  {formik.touched.check && formik.errors.check}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <ReCAPTCHA
                  className={classes.recaptcha}
                  sitekey={
                    process.env.REACT_APP_PLATAFORM === 'crevettic'
                      ? '6LeOkXYdAAAAAMXuoD12Qm6yUzZyZwIRewCy_zCT'
                      : '6LcvnXYdAAAAAFd-l9KbUs3YmADoBJs-iBBe_xjZ'
                  }
                  onChange={onChangeRecaptcha}
                />
              </Grid>

              <Grid item xs={12}>
                <FormGroup>
                  <Button
                    style={{ borderRadius: '15px' }}
                    className={classes.buttonRegister}
                    variant="contained"
                    onClick={() => {
                      changeContractAccepted();
                    }}
                    size="large"
                  >
                    {loading ? <CircularProgress /> : 'Efetuar Cadastro'}
                  </Button>
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  Já tem cadastro?
                  <Link
                    style={{ textDecoration: 'none', color: '#1572C6' }}
                    to="/signin"
                  >
                    {' '}
                    Faça seu login{' '}
                  </Link>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  Esqueceu a senha?
                  <span
                    onClick={() => setOpenDialogForgotPass(true)}
                    style={{ color: '#1572C6', cursor: 'pointer' }}
                  >
                    {' '}
                    Redefinir minha senha!
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </form>
        </Paper>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          autoHideDuration={6000}
        >
          <Alert severity="success">Ação Submetida com Sucesso!</Alert>
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={openError}
          onClose={handleClose}
          autoHideDuration={3000}
        >
          <Alert severity="error">
            Erro ao submeter ação! Tente novamente.
          </Alert>
        </Snackbar>
      </Container>

      <Dialog
        open={isInvite}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Para cadastar um novo usuário é preciso deslogar o usuário conectado
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => history.push('/home')} color="secondary">
            Continuar
          </Button>
          <Button onClick={handleLogout} color="primary">
            Deslogar
          </Button>
        </DialogActions>
      </Dialog>

      <DialogContact />

      {openDialogForgotPass && (
        <DialogForgotPass close={() => setOpenDialogForgotPass(false)} />
      )}
    </>
  );
}

export default withRouter(Register);
